import React from "react";

import { Link } from "react-router-dom";
import { user } from "redux-store/user/user.selectors";
import { useSelector } from "react-redux";
import oncotectFullLogoSvg from "assets/images/Oncotect_Logo_-_Stacked_116x100.svg";

const Footer = () => {
  const loggedInUser = useSelector(user);

  return (
    <footer className="tw-px-0">
      <div className="tw-w-full tw-bg-[#F7F6F4] shadow-footerShadow">
        <div className="tw-w-[93%] tw-mx-auto tw-flex tw-flex-col tw-gap-2">
          {/* 1st row */}
          <div className="tw-w-full tw-flex tw-items-start tw-gap-10 lg:tw-gap-20 tw-flex-col lg:tw-flex-row tw-py-10 lg:tw-py-24">
            {/* 1st item */}
            <div className="tw-flex lg:tw-w-[11%] xl:tw-w-[9%] tw-self-center lg:tw-self-start">
              <div className="tw-flex tw-flex-col tw-items-center">
                <Link
                  // to={loggedInUser?.isAdmin ? "/admin/dashboard" : "/user/home"}
                  to={"https://oncotect.co"}
                  className="tw-flex tw-justify-center"
                >
                  <img
                    className="tw-w-full"
                    src={oncotectFullLogoSvg}
                    alt="oncotect full logo"
                  />
                </Link>
              </div>
            </div>
            <div className=" tw-flex tw-flex-col lg:tw-flex-row tw-gap-8 lg:tw-gap-16 lg:tw-text-left md:tw-text-center tw-text-center tw-self-center">
              {/* 2nd item */}
              <div className="tw-flex tw-flex-col tw-space-y-[0.5rem]">
                <p className="tw-text-[12px] tw-font-bold tw-text-darkPurple tw-tracking-wider">
                  FOR PET PARENTS
                </p>
                <a
                  href="https://oncotect.co/pages/for-pet-parents"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="tw-cursor-pointer hover:tw-text-reddishOrange tw-text-[14px] tw-font-light tw-text-darkPurple"
                >
                  Pet Cancer Screening
                </a>
                <a
                  href="https://oncotect.co/products/oncotect-for-dogs"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="tw-cursor-pointer hover:tw-text-reddishOrange tw-text-[14px] tw-font-light tw-text-darkPurple"
                >
                  Pre Order your Test
                </a>
                <a
                  href="https://oncotect.co/pages/locations"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="tw-cursor-pointer hover:tw-text-reddishOrange tw-text-[14px] tw-font-light tw-text-darkPurple"
                >
                  Find Oncotect
                </a>
                <a
                  href="https://oncotect.co/blogs/resources/tagged/for-pet-parents"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="tw-cursor-pointer hover:tw-text-reddishOrange tw-text-[14px] tw-font-light tw-text-darkPurple"
                >
                  Resources
                </a>
                <a
                  href="https://oncotect.co/pages/faqs"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="tw-cursor-pointer hover:tw-text-reddishOrange tw-text-[14px] tw-font-light tw-text-darkPurple"
                >
                  FAQs
                </a>
              </div>
              {/* 3rd item */}
              <div className="tw-flex tw-flex-col tw-space-y-[0.5rem] ">
                <p className="tw-text-[12px] tw-font-bold tw-text-darkPurple tw-tracking-wider">
                  FOR VETERINARIANS
                </p>
                <a
                  href="https://oncotect.co/pages/for-veterinarians"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="tw-cursor-pointer hover:tw-text-reddishOrange tw-text-[14px] tw-font-light tw-text-darkPurple"
                >
                  Benefits of Oncotect
                </a>
                <a
                  href="https://oncotect.co/blogs/resources/oncotect-vs-petdx-vs-violition"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="tw-cursor-pointer hover:tw-text-reddishOrange tw-text-[14px] tw-font-light tw-text-darkPurple"
                >
                  Comparing Test
                </a>
                <a
                  href="https://oncotect.co/blogs/resources/tagged/for-veterinarians"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="tw-cursor-pointer hover:tw-text-reddishOrange tw-text-[14px] tw-font-light tw-text-darkPurple"
                >
                  Case Studies
                </a>
                <a
                  href="https://oncotect.co/pages/contact"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="tw-cursor-pointer hover:tw-text-reddishOrange tw-text-[14px] tw-font-light tw-text-darkPurple"
                >
                  Inquire Today
                </a>
                <a
                  href="https://oncotect.co/pages/faqs"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="tw-cursor-pointer hover:tw-text-reddishOrange tw-text-[14px] tw-font-light tw-text-darkPurple"
                >
                  FAQs
                </a>
              </div>
              {/* 4th item */}
              <div className="tw-flex tw-flex-col tw-space-y-[0.5rem]">
                <p className="tw-text-[12px] tw-font-bold tw-text-darkPurple tw-tracking-wider">
                  Social
                </p>

                <a
                  href="https://facebook.com/oncotect"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="tw-cursor-pointer hover:tw-text-reddishOrange tw-text-[14px] tw-font-light tw-text-darkPurple"
                >
                  Facebook
                </a>
                <a
                  href="https://twitter.com/oncotect"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="tw-cursor-pointer hover:tw-text-reddishOrange tw-text-[14px] tw-font-light tw-text-darkPurple"
                >
                  Twitter
                </a>
                <a
                  href="https://oncotect.co/products/www.pinterest.com/oncotect"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="tw-cursor-pointer hover:tw-text-reddishOrange tw-text-[14px] tw-font-light tw-text-darkPurple"
                >
                  Pinterest
                </a>
                <a
                  href="https://instagram.com/oncotect"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="tw-cursor-pointer hover:tw-text-reddishOrange tw-text-[14px] tw-font-light tw-text-darkPurple"
                >
                  Instagram
                </a>
                <a
                  href="https://tiktok.com/@oncotect"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="tw-cursor-pointer hover:tw-text-reddishOrange tw-text-[14px] tw-font-light tw-text-darkPurple"
                >
                  TikTok
                </a>
                <a
                  href="https://www.youtube.com/@oncotect-tr1nf/featured"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="tw-cursor-pointer hover:tw-text-reddishOrange tw-text-[14px] tw-font-light tw-text-darkPurple"
                >
                  YouTube
                </a>
                <a
                  href="https://www.linkedin.com/company/oncotect"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="tw-cursor-pointer hover:tw-text-reddishOrange tw-text-[14px] tw-font-light tw-text-darkPurple"
                >
                  LinkedIn
                </a>
              </div>
            </div>

            {/* 5th item */}
            <div className="tw-flex tw-flex-col tw-space-y-3 tw-flex-[3] lg:tw-text-left md:tw-text-center tw-text-center">
              <div className="tw-flex tw-flex-col tw-space-y-2">
                <p className="tw-text-[12px] tw-font-bold tw-text-darkPurple tw-tracking-wider">
                  ABOUT ONCOTECT
                </p>
                <p className="tw-text-[14px] tw-font-light tw-text-darkPurple">
                  Raleigh based biotech startup committed to pioneering early
                  screening of cancer risks in dogs. Oncotect is the only
                  urine-based, non-invasive, convenient, affordable, and
                  accessible multi-cancer screening test for dogs.
                </p>
              </div>
              <div>
                <div className="tw-flex tw-flex-col">
                  <p className="tw-text-[14px] tw-font-bold tw-text-darkPurple tw-tracking-wider">
                    For General Inquiries
                  </p>
                  <p className="tw-text-[14px] tw-font-light tw-text-reddishOrange">
                    <a href="mailto:hello@oncotect.co">hello@oncotect.co</a>
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* 2nd row */}

          <div className=" tw-text-darkPurple tw-w-full tw-flex tw-flex-col lg:tw-items-start tw-items-center tw-space-y-3 tw-font-medium tw-pb-2 ">
            {/* 1st item */}
            {/* <div className="tw-justify-center lg:tw-justify-start lg:tw-text-left"> */}
            <p className="tw-text-[12px] tw-font-bold  tw-tracking-wider  tw-text-center">
              Important Disclosure on Oncotect Test Results
            </p>
            {/* </div> */}
            {/* 2nd item */}
            <div className="tw-flex tw-flex-col tw-space-y-[0.5rem]">
              <p className="tw-text-[13px] tw-font-light tw-leading-5 tw-text-center lg:tw-text-left md:tw-text-center tw-justify-center">
                Please be advised that the early screening test results provided
                by Oncotect are not intended to serve as a definitive diagnosis.
                Oncotect is a risk assessment tool based on clinical studies of
                four cancer types (lymphoma, hemangiosarcoma, mast cell tumor,
                and melanoma) and is designed to evaluate the risk of cancer at
                the time the test was performed. The “low,” “moderate,” or “high
                risk” results do not confirm or rule out cancer. It is crucial
                for pet owners not to rely solely on the results of Oncotect for
                diagnostic purposes, but instead to consult with their
                veterinarian for proper interpretation and guidance. Further
                testing and/or examination may be recommended by the
                veterinarian to obtain a more accurate assessment of your pet’s
                health. By using Oncotect, you acknowledge and understand the
                limitations of the test and agree that the company providing the
                Oncotect test shall not be held liable for any
                misinterpretation.
              </p>
              <div className="tw-text-[12px] tw-font-light tw-flex tw-justify-center lg:tw-justify-start tw-gap-4 lg:tw-text-lef tw-py-4">
                <a
                  className=" hover:tw-underline tw-cursor-pointer hover:tw-text-black"
                  href="https://oncotect.co/pages/terms-of-use"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Terms of Use
                </a>
                <a
                  className=" hover:tw-underline tw-cursor-pointer hover:tw-text-black"
                  href="https://oncotect.co/pages/privacy-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy Policy
                </a>
              </div>
              <p className="tw-text-[12px] tw-font-light lg:tw-text-left tw-text-center">
                2023 Oncotect. All rights reserved. Made with love in North
                Carolina.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
